import { Component, OnDestroy, OnInit } from '@angular/core';
import { HxProductSplitDefinitionService, ProductInfoModel, ProductInfoType, ProductSplitDefinitionFullModel, ProductSplitDefinitionRequest, Shape } from 'hx-services';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { ActivatedRoute, Data, Router } from '@angular/router';
import { NzModalService } from 'ng-zorro-antd/modal';
import { TranslocoDirective, TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { getFormErrors } from '@adm-web-app/utils';
import { NzAffixComponent } from 'ng-zorro-antd/affix';
import { HxBreadcrumbsComponent } from '@adm-web-app/components/breadcrumbs/breadcrumbs.component';
import { NzPageHeaderComponent, NzPageHeaderTitleDirective } from 'ng-zorro-antd/page-header';
import { NzSkeletonComponent } from 'ng-zorro-antd/skeleton';
import { NzFormControlComponent, NzFormDirective, NzFormItemComponent, NzFormLabelComponent } from 'ng-zorro-antd/form';
import { NzColDirective, NzRowDirective } from 'ng-zorro-antd/grid';
import { HxEnumSelectComponent, HxProductInfoSelectComponent } from 'hx-components';
import { NzOptionComponent, NzSelectComponent } from 'ng-zorro-antd/select';
import { NgFor, NgIf } from '@angular/common';
import { NzAlertComponent } from 'ng-zorro-antd/alert';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { NzWaveDirective } from 'ng-zorro-antd/core/wave';

import { NzIconDirective } from 'ng-zorro-antd/icon';
import { NzTagComponent } from 'ng-zorro-antd/tag';

@Component({
    selector: 'hc-product-def-split-edit',
    templateUrl: './product-def-split-edit.component.html',
    styleUrls: ['./product-def-split-edit.component.less'],
  imports: [NzAffixComponent, HxBreadcrumbsComponent, NzPageHeaderComponent, NzPageHeaderTitleDirective, NzSkeletonComponent, TranslocoDirective, FormsModule, NzFormDirective, ReactiveFormsModule, NzRowDirective, NzColDirective, NzFormItemComponent, NzFormLabelComponent, NzFormControlComponent, HxProductInfoSelectComponent, HxEnumSelectComponent, NzSelectComponent, NgFor, NzOptionComponent, NgIf, NzAlertComponent, NzButtonComponent, NzWaveDirective, NzIconDirective, NzTagComponent, TranslocoPipe]
})
export class ProductDefSplitEditComponent implements OnInit, OnDestroy {
  model!: ProductSplitDefinitionFullModel;
  productInfo!: ProductInfoModel;
  isEdit = false;
  isCreate = false;
  form!: UntypedFormGroup;
  isLoading = {
    model: false,
  };
  isSaving = false;
  Shape = Shape;
  types = [ProductInfoType.PRODUCT, ProductInfoType.PROPERTY, ProductInfoType.SERVICE];
  splitQuantityOptions = [2, 3, 4, 5, 6, 8, 10, 12];
  productSizeOptions = ['1', '1/2', '1/3', '1/4', '1/5', '1/6', '1/8', '1/10', '1/12'];
  private $destroyed = new Subject<void>();

  constructor(
    private aRoute: ActivatedRoute,
    private fb: UntypedFormBuilder,
    private modal: NzModalService,
    private productSplitDefinitionService: HxProductSplitDefinitionService,
    private tr: TranslocoService,
    private notification: NzNotificationService,
    private router: Router,
  ) {
  }

  ngOnInit() {
    const routeData: Data = this.aRoute.snapshot.data;
    this.model = routeData['splitDef'] as ProductSplitDefinitionFullModel;
    this.productInfo = this.aRoute.parent?.parent?.snapshot.data['productDef'] as ProductInfoModel;
    if (this.model) {
      this.isEdit = true;
    } else {
      this.model = {} as ProductSplitDefinitionFullModel;
      this.isCreate = true;
    }
    this.form = this.fb.group({
      inProductInfoId: [null, [Validators.required]],
      outProductInfoId: [null, [Validators.required]],
      splitQuantity: [null, [Validators.required]],
      shape: [null, [Validators.required]],
      inProductSize: [null, [Validators.required]]
    });
    this.updateForm();
  }

  ngOnDestroy(): void {
    this.$destroyed.next();
    this.$destroyed.complete();
  }

  submitForm() {
    Object.values(this.form.controls).forEach(ctrl => {
      ctrl.markAsDirty();
      ctrl.updateValueAndValidity();
    });
    if (this.form.valid) {
      this.form.disable();
      const formModel = this.form.getRawValue() as ProductSplitDefinitionRequest;
      const model: Partial<ProductSplitDefinitionRequest> = {
        inProductInfoId: formModel.inProductInfoId,
        outProductInfoId: formModel.outProductInfoId,
        splitQuantity: formModel.splitQuantity,
        shape: formModel.shape,
        inProductSize: formModel.inProductSize,
      };
      model.id = this.model.id;
      this.isSaving = true;
      this.productSplitDefinitionService.saveProductSplitDefinition(model).subscribe(result => {
        this.form.markAsPristine();
        this.notification.create(
          'success',
          'Разделение',
          this.tr.translate('nt.dataSaved')
        );
        if (this.isCreate) {
          this.router.navigate([`/product-definitions/${result.inProductInfoId}/edit`], { queryParams: { tab: 'split' } });
        } else {
          this.isLoading.model = true;
          this.productSplitDefinitionService.getProductSplitDefinitionById(result.id).subscribe(savedModel => {
            this.model = savedModel;
            this.isLoading.model = false;
            this.updateForm();
          });
        }
        this.form.enable();
        this.isSaving = false;
      }, () => {
        this.form.enable();
        this.isSaving = false;
      });
    } else {
      console.log('formErrors', getFormErrors(this.form));
    }
  }

  private updateForm() {
    const formModel: Partial<ProductSplitDefinitionRequest> = {
      inProductInfoId: this.productInfo.id,
      outProductInfoId: this.model.outProductInfo?.id,
      splitQuantity: this.model.splitQuantity,
      shape: this.model.shape,
      inProductSize: this.model.inProductSize,
    };

    this.form.patchValue(formModel);
  }
}
